import { academicYear as academicYearServices } from '@coligo-org/fe-common/services';

import Types from '../types';
import logger from '../../../../../../../common/services/logService';

import { ErrorsActions } from '../../../../../common/error/state';

export const fetchListStart = () => ({
  type: Types.FETCH_LIST_START,
});

export const fetchListEnd = () => ({
  type: Types.FETCH_LIST_END,
});

export const setList = list => ({
  type: Types.SET_LIST,
  payload: list,
});

export default ({ academicYearId, callback }) =>
  async dispatch => {
    try {
      dispatch(fetchListStart());
      const { data } = await academicYearServices.getClasses({
        academicYearId,
      });
      dispatch(setList(data));
      if (callback) callback({ data });
    } catch (error) {
      logger.log(error);
      if (error.response) {
        dispatch(ErrorsActions.addError(error.response.data.message));
      }
    } finally {
      dispatch(fetchListEnd());
    }
  };
